/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

function SingleTeamAppUI({ teamDetails, teamAppConfig, title, logo, logoAlt }) {
  return (
    <div className="col-12 col-md-4 col-lg-3 mb-4">
      <div className="data-container data-container--gradient p-4 d-flex flex-column justify-content-center align-items-center">
        <img
          style={{ maxHeight: 100 }}
          className="team-ticket-logo mb-4"
          src={logo}
          alt={logoAlt}
        />
        {title ? (
          <p className="heading-stats-name heading-stats-name--medium heading-name-ticket mt-0 mb-2 text-center">
            {title}
          </p>
        ) : null}
        <p className="text-caption mb-4">
          {teamDetails?.arena?.name ? teamDetails.arena.name : <>&nbsp;</>}
        </p>
        <div className="d-flex flex-row gap-2 w-100">
          <a
            href={teamAppConfig?.Appstore}
            target="_blank"
            rel="noreferrer"
            className="button button--primary-yellow d-block text-center w-50"
          >
            iOS
          </a>
          <a
            href={teamAppConfig?.GooglePlay}
            target="_blank"
            rel="noreferrer"
            className="button button--primary-yellow d-block text-center w-50"
          >
            Android
          </a>
        </div>
      </div>
    </div>
  );
}
export default SingleTeamAppUI;
